const required = (errorName) => {
  errorName = errorName || 'Required.'; // eslint-disable-line no-param-reassign
  return (value) => {
    if (Array.isArray(value)) {
      return value.length > 0 || errorName;
    }
    if (value === undefined || value === null) {
      return errorName;
    }

    const isValueString = typeof value === 'string';

    if (isValueString && value.trim() === '') {
      return errorName;
    }

    return true;
  };
};

const integer = (errorName) => {
  errorName = errorName || 'Must be a whole number.'; // eslint-disable-line no-param-reassign
  return (value) => {
    if (!value || `${value}`.match(/^-?[0-9]+$/)) {
      return true;
    }

    return errorName;
  };
};

const decimal = (errorName) => {
  errorName = errorName || 'Must be a whole number.'; // eslint-disable-line no-param-reassign
  return (value) => {
    if (!value || `${value}`.match(/^-?\d*\.?\d*$/)) {
      return true;
    }

    return errorName;
  };
};

const numberLessThan = errorName => maxValue => (value) => {
  const number = +value;
  if (number > maxValue) {
    return errorName || `Must be less than or equal to ${maxValue}.`;
  }
  return true;
};

const numberMoreThan = errorName => minValue => (value) => {
  const number = +value;
  if (number < minValue) {
    return errorName || `Must be more than or equal to ${minValue}.`;
  }
  return true;
};

const greaterThanZero = (errorName) => {
  errorName = errorName || 'Value must be greater than zero.'; // eslint-disable-line no-param-reassign
  return (value) => {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    const num = Number(value);

    return num > 0 || errorName;
  };
};

const lengthNotGreaterThan = (errorName = 'Input exceeds maximum allowed length', maximumAllowedValue) => (value) => {
  if (value === undefined || value === null) {
    return true;
  }

  return value.length <= maximumAllowedValue || errorName;
};

const validate = (refs) => {
  let valid = true;
  refs.forEach((ref) => {
    if (!ref.validate(true)) {
      ref.$attrs['data-error'] = true; // eslint-disable-line no-param-reassign
      valid = false;
    } else {
      ref.$attrs['data-error'] = false; // eslint-disable-line no-param-reassign
    }
  });

  return valid;
};

const getInvalidFieldNames = () => [...document.querySelectorAll('[data-error]')].map(p => p.name);

const isNumber = (errorName = 'Value must be a number.') => (value) => {
  if (value !== undefined && value !== null && value.toString().match(/E.*/i)) {
    return errorName;
  }

  const num = Number(value);

  return !Number.isNaN(num) || errorName;
};

const notEqualToZero = (errorName = 'Value cannot be zero.') => (value) => {
  if (value === undefined || value === null) {
    return true;
  }
  const num = Number(value);

  return num !== 0 || errorName;
};

const paymentDecimal = (errorName = 'Only two decimal places are allowed') => (value) => {
  if (value === undefined || value === null) {
    return true;
  }

  const valueStr = value.toString();
  if (valueStr.includes('.') && valueStr.split('.')[1].length > 2) {
    return errorName;
  }

  return true;
};

const priceNotGreaterThanInitialWhenOrdersExist = errorName => (ordersExist, initialValue) => (value) => {
  const number = +value;
  if (ordersExist && number > initialValue) {
    return errorName || `Can not be higher than initial price (${initialValue}) because selection was ordered.`;
  }
  return true;
};

const allowedKeyCodesForNumberInput = [
  8, 46, // Backspace, Delete
  37, 38, 39, 40, // Arrow keys left, up, right, down
];

const validateNumberInput = (keyboardEvent, limit) => {
  if (allowedKeyCodesForNumberInput.includes(keyboardEvent.keyCode)
    || ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(keyboardEvent.key)) {
    // Zero is not allowed to be the first digit
    if (keyboardEvent.target.selectionStart === 0 && keyboardEvent.key === '0') {
      keyboardEvent.preventDefault();
    }

    // Only arrow and delete keys allowed when input limit reached
    if (keyboardEvent.target.value.length >= limit && !allowedKeyCodesForNumberInput.includes(keyboardEvent.keyCode)) {
      keyboardEvent.preventDefault();
    }
  } else {
    keyboardEvent.preventDefault();
  }
};

export default {
  rules: {
    required,
    greaterThanZero,
    lengthNotGreaterThan,
    integer,
    decimal,
    numberLessThan,
    numberMoreThan,
    notEqualToZero,
    paymentDecimal,
    isNumber,
    priceNotGreaterThanInitialWhenOrdersExist,
  },
  validate,
  getInvalidFieldNames,
  validateNumberInput,
};
